import { Spacing } from '@persona-id/design-tokens';
import { FC, useContext } from 'react';
import styled from 'styled-components';

import NavbarLink from 'dashboard/components/Navbar/NavbarLink';
import { LEFT_NAV_WIDTH } from 'dashboard/components-lib/NavAndPanelsOverlay/constants';
import { NavAndPanelsOverlayContext } from 'dashboard/components-lib/NavAndPanelsOverlay/NavAndPanelsOverlay';
import { NavItem } from 'dashboard/components-lib/NavAndPanelsOverlay/types';
import { Z_INDICES } from 'dashboard/styles/variables';
import Tooltip from 'design-system/components/Tooltip';

const NavContainer = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: ${Z_INDICES.sideNav};
  height: 100%;
  width: ${LEFT_NAV_WIDTH}px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.background.primary};
  border: 1px solid ${({ theme }) => theme.color.border.primary};
  border-bottom: none;
`;

const NavSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Spacing[1]};
  padding: ${Spacing[2]};
  border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
  &:last-child {
    border-bottom: none;
  }
`;

export interface LeftNavProps {
  items: NavItem[][];
}

const LeftNav: FC<LeftNavProps> = ({ items }) => {
  return (
    <NavContainer>
      {items.map((section, index) => (
        <NavSection key={index}>
          {section.map((item) => (
            <NavItemButton key={item.label} item={item} />
          ))}
        </NavSection>
      ))}
    </NavContainer>
  );
};

interface NavItemButtonProps {
  item: NavItem;
}

const NavItemButton: FC<NavItemButtonProps> = ({ item }) => {
  const { activeNavItem, expandNavItem, collapseNavItem } = useContext(NavAndPanelsOverlayContext);
  const selected = activeNavItem?.label === item.label;
  return (
    <Tooltip
      side='right'
      interactive={false}
      zIndex={Z_INDICES.modalElevated}
      trigger={
        <div
          id={'left-nav-item-' + item.label}
          onClick={() => {
            if (selected) {
              // Close the panel if the item is already selected
              collapseNavItem();
            } else {
              expandNavItem(item);
            }
          }}
        >
          <NavbarLink
            selected={selected}
            isCollapsed={true}
            prefixIcon={item.icon}
            label={item.label}
            // Go to the base path if the item is already selected
            route={item.path && (selected ? item.path.basePath : item.path.to)}
            dataTest={'left-nav-item-' + item.label}
          />
        </div>
      }
    >
      {item.label}
    </Tooltip>
  );
};

export default LeftNav;
